
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";
import { membershipTypes, MembershipFormData } from "../types";

interface MembershipTypeFieldProps {
  form: UseFormReturn<MembershipFormData>;
}

export const MembershipTypeField = ({ form }: MembershipTypeFieldProps) => {
  return (
    <FormField
      control={form.control}
      name="membershipType"
      render={({ field }) => (
        <FormItem>
          <FormLabel>What type of membership would you like to apply for?*</FormLabel>
          <Select onValueChange={field.onChange} defaultValue={field.value}>
            <FormControl>
              <SelectTrigger className="bg-white">
                <SelectValue placeholder="Please Select" />
              </SelectTrigger>
            </FormControl>
            <SelectContent className="bg-white">
              {membershipTypes.map((type) => (
                <SelectItem key={type} value={type}>
                  {type}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
